import React, { lazy, Suspense } from 'react';
import { LoadingIndicator } from '../common/components/loading-indicator';

const MoreActionsMenu = lazy(() =>
    import('federated-search/MoreActionsMenu').then((module) => ({
        default: module.MoreActionsMenu,
    }))
);

export const FederatedSearchMoreActionsMenu = () => (
    <Suspense fallback={<LoadingIndicator />}>
        <MoreActionsMenu />
    </Suspense>
);
